import React from 'react';
import { Video } from 'lucide-react';
import { AppButton } from '../../../ui';
import { canJoin } from '../studentHomeRules';

/**
 * A class happening right now, above everything else. The Join control is a real
 * link so the classroom opens on a full page load, which the Zoom SDK needs.
 */
const LiveNow = ({ courses }) => {
  const live = courses.filter(canJoin);
  if (live.length === 0) return null;

  return (
    <div className="tw-grid tw-gap-2.5 page-md:tw-grid-cols-[repeat(auto-fit,minmax(320px,1fr))]">
      {live.map((course) => (
        <div
          key={course.id}
          className="tw-flex tw-min-w-0 tw-items-center tw-gap-3 tw-rounded-lg tw-border tw-border-solid tw-border-success/30 tw-bg-success-soft tw-px-4 tw-py-3"
        >
          <span className="tw-relative tw-flex tw-h-2.5 tw-w-2.5 tw-shrink-0" aria-hidden="true">
            <span className="tw-absolute tw-inset-0 tw-rounded-full tw-bg-success tw-opacity-60 tw-animate-ping motion-reduce:tw-animate-none" />
            <span className="tw-relative tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-success" />
          </span>
          <div className="tw-min-w-0 tw-flex-1">
            <div className="tw-text-[0.6875rem] tw-font-semibold tw-uppercase tw-tracking-caps tw-text-success-fg">Live now</div>
            <div className="tw-truncate tw-text-sm tw-font-semibold tw-text-content">{course.name}</div>
          </div>
          <AppButton as="a" href={`/s/classroom/${course.batchId}`} variant="success" size="sm" className="tw-shrink-0 tw-no-underline">
            <Video size={16} />
            Join
          </AppButton>
        </div>
      ))}
    </div>
  );
};

export default LiveNow;
